import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { EditLockerComponent } from "./edit-locker/edit-locker.component";
import { DataService_Locker } from "../shared/data.service";
import { LockerBasicRequest } from "../shared/LockerBasicRequest";
import { AddLockerComponent } from "./add-locker/add-locker.component";
import { AssignLockersComponent } from "./assign-lockers/assign-lockers.component";
import { ImportLockersComponent } from "./import-lockers/import-lockers.component";
import { ExportLockersComponent } from "./export-lockers/export-lockers.component";

@Component({
	selector: "caass-locker-table",
	templateUrl: "./locker-table.component.html",
	styleUrls: ["./locker-table.component.css"],
})
export class LockerTableComponent implements OnInit {
	constructor(
		// private userService: UserService,
		private LockerService: DataService_Locker,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		// this.loadLocker();
	}

	ngOnChanges() {
		this.loadLocker();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() School: any;
	@Output() SelectedLockerChanged: EventEmitter<any> = new EventEmitter();

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedLockers: any;
	lstLocker: any = [];

	//Filter lists
	lstAssignableDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LockerNum", header: "Locker" },
		{ field: "Comment", header: "Comment" },
		{ field: "AssignedComments", header: "Assigned Comments" },
		{ field: "AssignedToDesc", header: "Assigned To" },
		{ field: "AssignedDTDesc", header: "Assigned Date" },
		// { field: 'AssignableDesc', header: 'Assignable' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadLocker() {
		if (this.School == undefined || this.School.SchoolID == undefined) {
			return;
		}

		this.loading = true;

		this.SelectedLockers = [];
		this.SelectedLockerChanged.emit(null);

		var result = this.LockerService.LockerTableSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstLocker = response;

				//Load Data Filter Lists
				this.lstAssignableDesc = Array.from(new Set(this.lstLocker.map((item: any) => item.AssignableDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadLocker();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(AddLockerComponent, {
			header: "Add Locker",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				School: this.School,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLocker();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		//
		// Error Handling
		//
		if (this.SelectedLockers.length == 0) {
			this.errorMessage = "Select a locker to edit";
			return;
		}

		// var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(EditLockerComponent, {
			header: "Edit Locker",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedLocker: this.SelectedLockers[0], //Edit 1st in list
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLocker();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//
		// Error handling
		//

		if (this.SelectedLockers.length == 0) {
			this.errorMessage = "Select Lockers to Unassign";
			return;
		}

		//
		// Confirm Delete
		//

		var MSG = "You are about to delete " + this.SelectedLockers.length + " locker" + (this.SelectedLockers.length != 1 ? "s" : "") + ".";
		MSG += " This will delete the selected lockers and their history. Do you want to continue?";

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Delete Lockers",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
			reject: () => {
				return;
			},
		});
	}

	FinishDelete() {
		this.processing = true;

		//
		// Create Request
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedLockers.length; z++) {
			var next = this.SelectedLockers[z];

			lstIDs = [...lstIDs, next.LockerID];
		}

		let parms: LockerBasicRequest = {
			lstLockerIDs: lstIDs,
		};

		//
		// Send Request
		//
		var result = this.LockerService.DeleteLockers(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					this.loadLocker();
				} else {
					//Error Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the lockers: " + response[0],
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onAssign() {
		this.errorMessage = "";

		//
		// Error handling
		//
		this.SelectedLockers = this.SelectedLockers.filter((locker) => locker.Assignable == true);

		if (this.SelectedLockers.length == 0) {
			this.errorMessage = "Select Lockers to Assign students to";
			return;
		}

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(AssignLockersComponent, {
			header: "Assign Lockers",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				School: this.School,
				SelectedLockers: this.SelectedLockers,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLocker();
			}
		});
	}

	onUnassign() {
		this.errorMessage = "";

		//
		// Error handling
		//

		//Unselect lockers that aren't assigned (can't unassign ones that are already unassigned)
		this.SelectedLockers = this.SelectedLockers.filter((locker) => locker.Assignable == false);

		if (this.SelectedLockers.length == 0) {
			this.errorMessage = "Select Lockers to Unassign";
			return;
		}

		this.processing = true;

		//
		// Create Request
		//

		var lstIDs: number[] = [];

		for (var z = 0; z < this.SelectedLockers.length; z++) {
			var next = this.SelectedLockers[z];

			lstIDs = [...lstIDs, next.LockerID];
		}

		let parms: LockerBasicRequest = {
			lstLockerIDs: lstIDs,
		};

		//
		// Send Request
		//
		var result = this.LockerService.UnassignLockers(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					this.loadLocker();
				} else {
					//Error Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not unassign the lockers: " + response[0],
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onImport() {
		this.errorMessage = "";

		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(ImportLockersComponent, {
			header: "Import Lockers",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				School: this.School,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLocker();
			}
		});
	}

	onExport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ExportLockersComponent, {
			header: "Export Lockers",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				School: this.School,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadLocker();
			}
		});
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		if (this.SelectedLockers.length > 0) {
			this.SelectedLockerChanged.emit(this.SelectedLockers[0]);
		} else {
			this.SelectedLockerChanged.emit(null);
		}

		// this.SelectedLocker = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		if (this.SelectedLockers.length > 0) {
			this.SelectedLockerChanged.emit(this.SelectedLockers[0]);
		} else {
			this.SelectedLockerChanged.emit(null);
		}

		// this.SelectedLocker = null;
	}
	onRowDblClick(Locker) {
		this.errorMessage = "";

		if (this.SelectedLockers.length > 0) {
			this.SelectedLockerChanged.emit(this.SelectedLockers[0]);
		} else {
			this.SelectedLockerChanged.emit(null);
		}

		// this.SelectedLocker = Locker;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	AllClear(lstErrors): boolean {
		var ans = true;

		for (var z = 0; z < lstErrors.length; z++) {
			var next = lstErrors[z];

			if (String(next) != "") {
				ans = false;
				return;
			}
		}

		return ans;
	}

	////////////////////////////////////////////
}
